export default class InputSmooth {
  constructor () {
    this.selectorSmooth = "[data-is-input-smooth]"
    this.inputs = document.querySelectorAll(this.selectorSmooth)
    this.filledClass = "input--filled"

    if (!this.inputs.length) return

    this.inputs.forEach((input) => {
      if (input.value.trim() !== "") {
        this.onInputFilled(input)
        return
      }

      if (input.getAttribute("type") === "password") {
        setTimeout(() => {
          try {
            if (input.matches(":-webkit-autofill")) {
              this.onInputFilled(input)
            }
          } catch (error) {}
        }, 100)
      }
    })

    this.bindEvents()
  }

  bindEvents () {
    this.inputs.forEach((input) => {
      input.addEventListener("input", () => this.onInputFilled(input))
      input.addEventListener("focus", () => this.onInputFilled(input))
      input.addEventListener("blur", () => {
        if (input.value.trim() === "") {
          this.onInputEmpty(input)
        }
      })
    })
  }

  onInputFilled (input) {
    input.classList.add(this.filledClass)
  }

  onInputEmpty (input) {
    input.classList.remove(this.filledClass)
  }
}
